const APP_KEY = 'O5p8NjD8OkNJ0VGv7psk82A8E3BtLuQZc2ZafMji';
const STAR_PATH = 'M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z';

const requests = new Map();

function star(filled) {
  const color = filled ? '#fbbf24' : '#e5e5e5';
  return `<svg class="size-4" viewBox="0 0 20 20" fill="${color}" aria-hidden="true"><path d="${STAR_PATH}"/></svg>`;
}

function fetchBottomline(pid) {
  if (!requests.has(pid)) {
    const url = `https://api-cdn.yotpo.com/v3/storefront/store/${APP_KEY}/product/${pid}/reviews?page=1&perPage=1`;
    requests.set(pid, fetch(url)
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        const bottomline = data?.bottomline;
        if (!bottomline?.totalReview) return null;
        return { score: bottomline.averageScore, count: bottomline.totalReview };
      })
      .catch(() => null));
  }
  return requests.get(pid);
}

class YotpoBottomline extends HTMLElement {
  async connectedCallback() {
    const pid = this.dataset.productId;
    if (!pid) { this.remove(); return; }
    this.hydrate(await fetchBottomline(pid));
  }

  hydrate(data) {
    if (!data || !data.count) {
      this.remove();
      return;
    }

    const { score, count } = data;
    const rounded = Math.round(score);
    const stars = Array.from({ length: 5 }, (_, i) => star(i < rounded)).join('');
    const display = `${score.toFixed(1)} (${count} review${count === 1 ? '' : 's'})`;
    const variant = this.dataset.variant || 'card';

    if (variant === 'link') {
      this.innerHTML = `
        <a href="#reviews" class="flex items-center gap-2 group w-fit" aria-label="Rated ${score.toFixed(1)} out of 5 from ${count} reviews. Jump to reviews">
          <span class="flex items-center gap-1" aria-hidden="true">${stars}</span>
          <span class="font-medium text-sm leading-5 text-[#3b4041] group-hover:underline">${display}</span>
        </a>
      `;
    } else {
      this.innerHTML = `
        <div class="flex items-center gap-1" aria-label="Rated ${score.toFixed(1)} out of 5 from ${count} reviews">
          ${stars}
          <span class="text-sm leading-5 text-[#737373] ml-1">${display}</span>
        </div>
      `;
    }
  }
}

if (!customElements.get('yotpo-bottomline')) {
  customElements.define('yotpo-bottomline', YotpoBottomline);
}
